export const aiFakeNames = [
  'Alex Rivers',
  'Emma Hayes',
  'Liam Green',
  'Sophia Woods',
  'Ethan Parker',
  'Ava Brooks',
  'Mason Clark',
  'Isabella White',
  'Noah Reed',
  'Mia Stone',
  'Lucas Gray',
  'Olivia Moore',
  'Benjamin Lane',
  'Charlotte Hill',
  'James Ford',
  'Amelia Carter',
  'Henry Knight',
  'Emily Scott',
  'William Cross',
  'Ella Miles',
  'Jack Fox',
  'Harper Ray',
  'Daniel Flynn',
  'Grace Hart',
  'Michael Ross',
  'Lily West',
  'Matthew Lake',
  'Chloe Archer',
  'Jacob Quinn',
  'Sophie Blake',
  'Andrew Vale',
  'Hannah Dean',
  'Samuel Drake',
  'Abigail Page',
  'Joshua Cole',
  'Natalie Frost',
  'David Brook',
  'Victoria Lane',
  'Christopher Wade',
  'Megan Nash',
  'Elijah Kerr',
  'Zoe Harper',
  'Sebastian Finn',
  'Madison Gray',
  'Dylan James',
  'Aria Reid',
  'Logan Stone',
  'Scarlett Day',
  'Owen Hale',
  'Lucy Lane',
]

export const aiOfficialNames = [
  'FireBotX',
  'AquaIntellect',
  'LeafAI',
  'PyroAI',
  'BotFlame',
  'HydraAI',
  'LeafGuard',
  'InfernoBot',
  'WaterSynth',
  'LeafSentient',
  'BlazeAI',
  'CascadeBot',
  'FloraIntelligence',
  'IgnisAI',
  'AquaBot',
  'BotanicalAI',
  'WildfireBot',
  'HydroMind',
  'ArboristAI',
  'TideSynth',
  'BlazingBot',
  'TsunamiAI',
  'EmberAI',
  'TempestBot',
  'ArborealAI',
  'RipTideBot',
  'IgnitionAI',
  'AbyssalBot',
  'BotanyMind',
  'PyroWarden',
  'HydroGuard',
  'LeafSentinel',
  'BlazeSage',
  'AquaKeeper',
  'VerdantVigil',
  'InfernoGuide',
  'FloraProtector',
  'FlameWatcher',
  'TideMaster',
  'GroveGuardian',
  'EmberMentor',
  'TsunamiSeer',
  'ThornBot',
  'IgnisMentor',
  'AbyssWalker',
  'SylvanWarden',
  'BlazingGale',
  'Torrential',
  'BrambleSentinel',
  'CinderOracle',
  'TempestWarden',
  'FoliageBot',
  'WildfireGuide',
  'AquaticSage',
  'ArboristBot',
  'ScorchKeeper',
  'LushDefender',
]
